<h1>Posting to the Feed</h1>
<button (click)="share()" class="btn btn-primary">Share Dialog</button>
<button (click)="feed()" class="btn btn-primary">Feed Dialog</button>
<button (click)="feed2()" class="btn btn-primary">Feed Dialog (More Info)</button>

<h1>Login into Facebook to get Page Access Token</h1>
<button (click)="loginAndGetPageToken()" class="btn btn-primary">Login into FB</button>

<h1>Login into Facebook to get User Access Token</h1>
<button (click)="loginAndGetUserAccessToken()" class="btn btn-primary">Login into FB</button>



